import { render } from "./LoginAdmin.vue?vue&type=template&id=0984b768&scoped=true&ts=true"
import script from "./LoginAdmin.vue?vue&type=script&lang=ts"
export * from "./LoginAdmin.vue?vue&type=script&lang=ts"

import "./LoginAdmin.vue?vue&type=style&index=0&id=0984b768&scoped=true&lang=scss"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0984b768"]])

export default __exports__